import Vue from "vue"
import axios from "@/axios";
import moment from "moment";
import Responses from "@/common/pagination/entities/responses";
import Order, { OrderStatus } from "@/models/Order";
import PaginationResponse from "@/common/pagination/entities/pagination-response";
import OrdersRequestFilter from "@/models/OrdersRequestFilter";
import BaseService from "./base-service";
import Customer from "@/models/Customer";
import Restaurant from "@/models/Restaurant";
import Address from '@/models/Address';

class OrdersService extends BaseService {
  public async findAllAsync(status: OrderStatus) {
    const res = await axios.get<PaginationResponse<Order>>(
      `order/?api_key=${Vue.prototype.$apiKey}&status=${status}`
    );
    const list = Responses.pagedList(res);
    list.items.forEach(o => {
      this.ensureCustomer(o);
      this.ensureRestaurant(o);
      o.date = new Date(o.crdate * 1000);
    });
    return list;
  }

  public async findOneAsync(id: number | null) {
    if (id === null) {
      return null;
    }
    const res = await axios.get<Order>(
      `order/?api_key=${Vue.prototype.$apiKey}&uid=${id}`
    );
    let order = Responses.obj(res);
    this.ensureCustomer(order);
    return order;
  }

  public async updateEstimateCompleteAsync(id: number, time: Date) {
    const res = await axios.put(
      `order/?api_key=${Vue.prototype.$apiKey}&uid=${id}`,
      { status: OrderStatus.InProgress, estimate_complete: moment(time).unix() }
    );
    return Responses.obj(res);
  }

  public async updateReceiptPrintedAsync(id: number, printed: Boolean) {
    const res = await axios.put(
      `order/?api_key=${Vue.prototype.$apiKey}&uid=${id}`,
      { receipt_printed: printed ? 1 : 0 }
    );
    return Responses.obj(res);
  }

  public async updateStatusAsync(id: number, status: OrderStatus) {
    const res = await axios.put(
      `order/?api_key=${Vue.prototype.$apiKey}&uid=${id}`,
      { status: status }
    );
    return Responses.obj(res);
  }

  private ensureCustomer(order: Order | null) {
    if (order && !order.customer) {
      order.customer = new Customer();
    }
    if (order && !order.address) {
      order.address = new Address();
    }
  }

  private ensureRestaurant(order: Order | null) {
    if (order && !order.restaurant) {
      order.restaurant = new Restaurant();
    }
  }
}

export default new OrdersService();
